import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsHomeadvisorComponent } from './simple-icons-homeadvisor.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsHomeadvisorComponent ],
    exports:      [ SimpleIconsHomeadvisorComponent ],
    bootstrap:    []
})
export class SimpleIconsHomeadvisorModule {}
